import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { MdOutlineCalendarToday } from 'react-icons/md';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import '../../Styles/ActionTable.css';
import { useForm } from 'react-hook-form';

const ActionTable = ({ columns, rows, handleAddTask }) => {
    const { register, handleSubmit, formState: { errors }, control } = useForm();
    const [newRow, setNewRow] = useState({
        priority: '',
        date: null,
        formattedRange: '',
        assignedTo: '',
        task: '',
    });
    const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    const handleInputChange = (event, rowIndex, column) => {
        const { value } = event.target;
        const updatedRows = [...rows];
        updatedRows[rowIndex][column] = value;
        setNewRow({ ...newRow });
    };

    const handleAssignInto = (event, rowIndex, column) => {
        const { value } = event.target;
        const updatedRows = [...rows];
        updatedRows[rowIndex][column] = value;
        setNewRow({ ...newRow });
    };

    const handleCalendarIconClick = (rowIndex) => {
        setSelectedRowIndex(rowIndex);
        setIsCalendarModalOpen(true);
    };

    const handleCalendarCloseModal = () => {
        setIsCalendarModalOpen(false);
    };

    const handleCalendarSubmit = (selectedDate) => {
        if (selectedRowIndex !== null) {
            const updatedRows = [...rows];
            updatedRows[selectedRowIndex].date = selectedDate;
            updatedRows[selectedRowIndex].formattedRange = selectedDate.toLocaleDateString();
            setNewRow({ ...newRow });
            setIsCalendarModalOpen(false);
            setSelectedRowIndex(null);
        }
    };

    const onSubmit = (data) => {
        handleAddTask(data);
    };

    return (
        <TableContainer sx={{ borderRadius: 2, border: '1px solid hsl(var(--border))', overflow: 'hidden' }}>
            <Table sx={{ minWidth: 650 }}>
                <TableHead>
                    <TableRow >
                        {columns.map((column, index) => (
                            <TableCell sx={{ borderRadius: 2, border: '1px solid hsl(var(--border))', overflow: 'hidden' }} key={index}>{column}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <TableCell sx={{ borderRadius: 2, border: '1px solid hsl(var(--border))', overflow: 'hidden' }} key={colIndex}>
                                    {column === 'Task Name' ? (
                                        <input
                                            type="text"
                                            placeholder="Enter Task Name"
                                            {...register(`rows[${rowIndex}].task`, { required: 'Task Name is required' })}
                                            onChange={(event) => handleInputChange(event, rowIndex, 'task')}
                                        />
                                    ) : column === 'Assign Into' ? (
                                        <select
                                            {...register(`rows[${rowIndex}].assignedTo`, { required: 'Assigning person is required' })}
                                            value={row.assignedTo}
                                            onChange={(event) => handleAssignInto(event, rowIndex, 'assignedTo')}
                                        >
                                            <option value="Faizal">Faizal</option>
                                        </select>
                                    ) : column === 'Due Date' ? (
                                        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                            <input
                                                type="text"
                                                className="w-full focus:border-transparent focus:outline-none"
                                                value={row.formattedRange}
                                                placeholder="Select date"
                                                {...register(`rows[${rowIndex}].date`, { required: 'Due Date is required' })}
                                                onClick={() => handleCalendarIconClick(rowIndex)}
                                                readOnly
                                            />
                                            <Tooltip title="Calendar" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <MdOutlineCalendarToday
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'hsl(var(--primary))',
                                                    width: '10%',
                                                }}
                                                onClick={() => handleCalendarIconClick(rowIndex)}
                                            />
                                            </Tooltip>
                                        </div>
                                    ) : column === 'Priority' ? (
                                        <select
                                            {...register(`rows[${rowIndex}].priority`, { required: 'Priority is required' })}
                                            value={row.priority}
                                            onChange={(event) => handleInputChange(event, rowIndex, 'priority')}
                                        >
                                            <option value="low">Low</option>
                                            <option value="medium">Medium</option>
                                            <option value="high">High</option>
                                        </select>
                                    ) : (
                                        row[column]
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Modal open={isCalendarModalOpen} onClose={handleCalendarCloseModal}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'hsl(var(--card))', padding: '20px', outline: 0 }}>
                    <Card className="rounded-sm p-5 border border-gray-300">
                        <DayPicker
                            mode="single"
                            selected={rows[selectedRowIndex]?.date}
                            onSelect={(date) => handleCalendarSubmit(date)}
                        />
                    </Card>
                </div>
            </Modal>
        </TableContainer>
    );
};

ActionTable.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.string).isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleAddTask: PropTypes.func.isRequired,
};

export default ActionTable;
